export default __webpack_public_path__ + "static/media/blogs-management-icon.80743d41.svg";